import { useTranslation } from "react-i18next";
import { AltSymbolIcon, DirectionIcon } from "@scryerlabs/ui";
import type { TradingStrategyDto } from "../../../api/hooks/useTradingStrategies";

/** The icons the strategies above use, in words: a tooltip never shows on a phone. */
export function StrategyMarksKey({ strategies }: { strategies: TradingStrategyDto[] }) {
  const { t } = useTranslation("tradingStrategies");

  const altSymbols = strategies.some((strategy) => strategy.bullSymbol || strategy.bearSymbol);
  const directions = [
    ...new Set(
      strategies
        .map((strategy) => strategy.direction)
        .filter((direction): direction is number => direction !== undefined),
    ),
  ].sort((a, b) => a - b);

  if (!altSymbols && directions.length === 0) {
    return null;
  }

  return (
    <div className="d-flex flex-wrap gap-3 small text-body-secondary">
      {altSymbols && (
        <span className="d-inline-flex align-items-center gap-2">
          <AltSymbolIcon label={t("traits.altSymbols")} size={16} />
          {t("traits.altSymbols")}
        </span>
      )}
      {directions.map((direction) => (
        <span key={direction} className="d-inline-flex align-items-center gap-2">
          <DirectionIcon direction={direction} label={t(`traits.direction.${direction}`)} size={16} />
          {t(`traits.direction.${direction}`)}
        </span>
      ))}
    </div>
  );
}
